import React from "react";
import ReactDOM from "react-dom/client";
import { router } from "./routes/Routes.jsx";
import "./styles/global.css";
import { RouterProvider } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { toast } from "sonner";

// Global 429 handler — intercepts all fetch calls and shows a rate-limit toast,
// except for the AI endpoint which handles 429 inline inside its modal.
const _originalFetch = window.fetch.bind(window);
window.fetch = async (...args) => {
  const res = await _originalFetch(...args);
  if (res.status === 429) {
    const url = typeof args[0] === "string" ? args[0] : (args[0]?.url ?? "");
    const isAiEndpoint = url.includes("report-comments");
    if (!isAiEndpoint) {
      const body = await res.clone().json().catch(() => ({}));
      const retryMins = Math.ceil((body.retryAfterSeconds ?? 900) / 60);
      toast.error("Too many requests", {
        id: "rate-limit",
        description: `Please wait approximately ${retryMins} minute${retryMins !== 1 ? "s" : ""} before trying again.`,
        duration: 8000,
      });
    }
  }
  return res;
};

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
    tracesSampleRate: import.meta.env.MODE === "production" ? 0.2 : 0.0,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: import.meta.env.MODE === "production" ? 1.0 : 0.0,
    beforeSend(event) {
      const sensitiveKeys = [
        'studentName', 'oen', 'data'];
      if (event.request?.data && typeof event.request.data === 'object') {
        sensitiveKeys.forEach(k => {
          if (event.request.data[k] !== undefined) event.request.data[k] = '[Filtered]';
        });
      }
      return event;
    },
  });
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
